import Decimal from "decimal.js";

import { Order, Package, PackageItem } from "@megaron/fulfillment-contracts";

export function computeToPackItems(order: Order | undefined, packages: Package[]): PackageItem[] {
  if (!order) return [];
  const { items, packages: existingPackages, refunds = [] } = order;
  const refundedByLineItemId = new Map<string, number>();
  for (const refund of refunds) {
    for (const ri of refund.items ?? []) {
      refundedByLineItemId.set(ri.lineItemId, (refundedByLineItemId.get(ri.lineItemId) ?? 0) + ri.quantity);
    }
  }
  const packedCountMap = new Map<string, number>();
  const sourcePackages = packages.length ? packages : existingPackages ?? [];
  for (const pkg of sourcePackages) {
    for (const item of pkg.items) {
      packedCountMap.set(item.variantId, (packedCountMap.get(item.variantId) ?? 0) + item.quantity);
    }
  }
  const orderQtyByKey = new Map<string, PackageItem>();
  for (const line of items ?? []) {
    const refundedQty = refundedByLineItemId.get(line.lineItemId) ?? 0;
    const effectiveLineQty = Math.max(0, line.quantity - refundedQty);
    if (effectiveLineQty <= 0) continue;
    const key = line.barcode || line.variantId;
    const existing = orderQtyByKey.get(key);
    if (existing) {
      existing.quantity += effectiveLineQty;
    } else {
      orderQtyByKey.set(key, { ...line, quantity: effectiveLineQty });
    }
  }
  const result: PackageItem[] = [];
  for (const entry of orderQtyByKey.values()) {
    const packedQty = packedCountMap.get(entry.variantId) ?? 0;
    const remainingQty = Math.max(0, entry.quantity - packedQty);
    const weight = entry.weight instanceof Decimal ? entry.weight : new Decimal(String(entry.weight ?? 0));
    const price = entry.price instanceof Decimal ? entry.price : new Decimal(String(entry.price ?? 0));
    result.push({ ...entry, quantity: remainingQty, weight, price });
  }
  return result;
}
